import { UpdateResolver } from '@urql/exchange-graphcache';

import { invalidateQuery } from '@/helper/urqlClient/cache/cacheHelpers';

export function updateFileMutation(): UpdateResolver {
  return (result, queryArgs, cache, info) => {
    invalidateQuery('files')(result, queryArgs, cache, info);
  };
}
